/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePermissionSnapshotInput,
  GetApiUserManagementV1PermissionSnapshotsIdComparisonParams,
  GetApiUserManagementV1PermissionSnapshotsParams,
  SnapshotComparisonDto
} from '../model';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getApiUserManagementV1PermissionSnapshots = (
  params?: GetApiUserManagementV1PermissionSnapshotsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/permission-snapshots`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1PermissionSnapshotsQueryKey = (params?: GetApiUserManagementV1PermissionSnapshotsParams) => {
  return [`/api/user-management/v1/permission-snapshots`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1PermissionSnapshotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1PermissionSnapshotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1PermissionSnapshotsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>> = ({ signal }) =>
    getApiUserManagementV1PermissionSnapshots(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1PermissionSnapshotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>
>;
export type GetApiUserManagementV1PermissionSnapshotsQueryError = unknown;

export function useGetApiUserManagementV1PermissionSnapshots<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>,
  TError = unknown
>(
  params: undefined | GetApiUserManagementV1PermissionSnapshotsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1PermissionSnapshots<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1PermissionSnapshotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1PermissionSnapshots<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1PermissionSnapshotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1PermissionSnapshots<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1PermissionSnapshotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshots>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1PermissionSnapshotsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const postApiUserManagementV1PermissionSnapshots = (
  createPermissionSnapshotInput: CreatePermissionSnapshotInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/permission-snapshots`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPermissionSnapshotInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1PermissionSnapshotsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1PermissionSnapshots>>,
    TError,
    { data: CreatePermissionSnapshotInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1PermissionSnapshots>>,
  TError,
  { data: CreatePermissionSnapshotInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1PermissionSnapshots'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1PermissionSnapshots>>,
    { data: CreatePermissionSnapshotInput }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUserManagementV1PermissionSnapshots(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1PermissionSnapshotsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1PermissionSnapshots>>
>;
export type PostApiUserManagementV1PermissionSnapshotsMutationBody = CreatePermissionSnapshotInput;
export type PostApiUserManagementV1PermissionSnapshotsMutationError = unknown;

export const usePostApiUserManagementV1PermissionSnapshots = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1PermissionSnapshots>>,
      TError,
      { data: CreatePermissionSnapshotInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1PermissionSnapshots>>,
  TError,
  { data: CreatePermissionSnapshotInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1PermissionSnapshotsMutationOptions(options), queryClient);
};
export const getApiUserManagementV1PermissionSnapshotsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/permission-snapshots/${id}`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1PermissionSnapshotsIdQueryKey = (id: number) => {
  return [`/api/user-management/v1/permission-snapshots/${id}`] as const;
};

export const getGetApiUserManagementV1PermissionSnapshotsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1PermissionSnapshotsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>> = ({ signal }) =>
    getApiUserManagementV1PermissionSnapshotsId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1PermissionSnapshotsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>
>;
export type GetApiUserManagementV1PermissionSnapshotsIdQueryError = unknown;

export function useGetApiUserManagementV1PermissionSnapshotsId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>,
  TError = unknown
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1PermissionSnapshotsId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1PermissionSnapshotsId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1PermissionSnapshotsId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1PermissionSnapshotsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1PermissionSnapshotsIdFile = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/permission-snapshots/${id}/file`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1PermissionSnapshotsIdFileQueryKey = (id: number) => {
  return [`/api/user-management/v1/permission-snapshots/${id}/file`] as const;
};

export const getGetApiUserManagementV1PermissionSnapshotsIdFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1PermissionSnapshotsIdFileQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>> = ({ signal }) =>
    getApiUserManagementV1PermissionSnapshotsIdFile(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1PermissionSnapshotsIdFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>
>;
export type GetApiUserManagementV1PermissionSnapshotsIdFileQueryError = unknown;

export function useGetApiUserManagementV1PermissionSnapshotsIdFile<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>,
  TError = unknown
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1PermissionSnapshotsIdFile<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1PermissionSnapshotsIdFile<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1PermissionSnapshotsIdFile<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdFile>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1PermissionSnapshotsIdFileQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1PermissionSnapshotsIdComparison = (
  id: number,
  params?: GetApiUserManagementV1PermissionSnapshotsIdComparisonParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<SnapshotComparisonDto>(
    { url: `/api/user-management/v1/permission-snapshots/${id}/comparison`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiUserManagementV1PermissionSnapshotsIdComparisonQueryKey = (
  id: number,
  params?: GetApiUserManagementV1PermissionSnapshotsIdComparisonParams
) => {
  return [`/api/user-management/v1/permission-snapshots/${id}/comparison`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1PermissionSnapshotsIdComparisonQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>,
  TError = unknown
>(
  id: number,
  params?: GetApiUserManagementV1PermissionSnapshotsIdComparisonParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1PermissionSnapshotsIdComparisonQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>> = ({ signal }) =>
    getApiUserManagementV1PermissionSnapshotsIdComparison(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1PermissionSnapshotsIdComparisonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>
>;
export type GetApiUserManagementV1PermissionSnapshotsIdComparisonQueryError = unknown;

export function useGetApiUserManagementV1PermissionSnapshotsIdComparison<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>,
  TError = unknown
>(
  id: number,
  params: undefined | GetApiUserManagementV1PermissionSnapshotsIdComparisonParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1PermissionSnapshotsIdComparison<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>,
  TError = unknown
>(
  id: number,
  params?: GetApiUserManagementV1PermissionSnapshotsIdComparisonParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1PermissionSnapshotsIdComparison<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>,
  TError = unknown
>(
  id: number,
  params?: GetApiUserManagementV1PermissionSnapshotsIdComparisonParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1PermissionSnapshotsIdComparison<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>,
  TError = unknown
>(
  id: number,
  params?: GetApiUserManagementV1PermissionSnapshotsIdComparisonParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1PermissionSnapshotsIdComparison>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1PermissionSnapshotsIdComparisonQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
